import { createContext } from 'react'

export const MenuPortalContext = createContext<HTMLElement | null>(null)
